import { Link } from "react-router";

export interface FooterProps {
  version?: string | undefined;
  environment?: string | undefined;
  /** In-app Help page; omitted = no Help link. */
  helpHref?: string | undefined;
}

export function Footer({ version = "0.1.0", environment, helpHref }: FooterProps) {
  return (
    <footer className="flex h-10 shrink-0 items-center justify-between border-t border-border bg-surface px-4 text-xs text-muted-foreground sm:px-6">
      <span>© {new Date().getFullYear()} Academia HUB</span>
      <div className="flex items-center gap-3">
        {environment && environment !== "production" && (
          <span className="rounded-full bg-warning/15 px-2 py-0.5 font-medium text-warning-text">{environment}</span>
        )}
        {helpHref && (
          <Link to={helpHref} className="transition-colors hover:text-foreground">
            Help
          </Link>
        )}
        <span>v{version}</span>
      </div>
    </footer>
  );
}
